import React from 'react'
import UCFUploadWidgetModal from '@chegg-wt/core/components/Modals/UCFUploadWidgetModal'
import ExitPopupCfcModals from '@chegg-wt/core/components/Modals/ExitPopupCfcModals'
import { ViewPageExitIntentExperiences } from './types'
import { ROLE_SPECIFIC_MODALS, UPLOAD_MODAL } from './constants'

export interface ViewPageExitIntentsProps {
  configuredExperience?: ViewPageExitIntentExperiences
}

export const ViewPageExitIntents: React.FC<ViewPageExitIntentsProps> = ({
  configuredExperience,
}) =>
  ({
    [UPLOAD_MODAL]: <UCFUploadWidgetModal />,
    [ROLE_SPECIFIC_MODALS]: <ExitPopupCfcModals />,
  }[configuredExperience] || null)
